// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const CriticalFailedIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="CriticalFailedIcon" ref={forwardedRef} {...props}>
      <path d="m12.002 12.993-1.939-1.939-2 2-1.06-1.06 2-2-1.95-1.95 1.06-1.061 1.95 1.95 1.89-1.89 1.06 1.061-1.89 1.89 1.94 1.939z" />
      <path d="M9.293 1.513a1 1 0 0 1 1.414 0l7.78 7.78a1 1 0 0 1 0 1.414l-7.78 7.78a1 1 0 0 1-1.414 0l-7.78-7.78a1 1 0 0 1 0-1.414zM2.927 10 10 17.073 17.073 10 10 2.927z" />
    </SvgIcon>
  );
});

/**
 * Use to show failed processes
 * @public
 */
export const CriticalFailedIcon = /* @__PURE__ */ Object.assign(
  CriticalFailedIconComponent,
  { displayName: 'CriticalFailedIcon' },
);
